import { CassetteTapeIcon as PhosphorCassetteTapeIcon } from "@phosphor-icons/react/dist/ssr/CassetteTape";

import { createAppIcon } from "@/components/createAppIcon";

export const CassetteIcon = /* @__PURE__ */ createAppIcon(PhosphorCassetteTapeIcon);
